<template>
  <div class="table ">
    <div class="row">
      <div v-for="item in configField"  :class="item?.class??'col-lg-6 mb-5'">
        <p>{{item?.label}}</p>
        <el-input
            :value="information[item?.key]"
            :type="item?.type === 'textarea' ? 'textarea' : 'text'"
            :rows="item?.type === 'textarea' ? 3 : undefined"
            readonly
        />
      </div>
    </div>


  </div>
</template>
<script>
export default {
  name: "DetailInformation",
  props: {
    configField: {
      type: Array,
      required: true
    },
    information: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped>
.table{
  width: 100%;
  background-color: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #D6D5D5;
  padding: 15px;
}
</style>